export const messages = {
  en: {
    newOaWorkflowDoing: {
      myPending: 'My Pending',
      myCompleted: 'My Completed',
      refresh: 'Refresh',
      repairPending: 'Repair Pending',
      complaintPending: 'Complaint Pending',
      purchasePending: 'Purchase Pending',
      collectionPending: 'Collection Pending',
      contractApplyPending: 'Contract Draft Pending',
      contractChangePending: 'Contract Change Pending',
      allocationPending: 'Allocation Pending',
      itemReleasePending: 'Item Release Pending',
      visitPending: 'Visit Pending',
      repairCompleted: 'Repair Completed',
      complaintCompleted: 'Complaint Completed',
      purchaseCompleted: 'Purchase Completed',
      collectionCompleted: 'Collection Completed',
      contractApplyCompleted: 'Contract Draft Completed',
      contractChangeCompleted: 'Contract Change Completed',
      allocationCompleted: 'Allocation Completed',
      itemReleaseCompleted: 'Item Release Completed',
      visitCompleted: 'Visit Completed',
      pending: 'Pending',
      completed: 'Completed'
    }
  },
  zh: {
    newOaWorkflowDoing: {
      myPending: '我的待办',
      myCompleted: '我的已办',
      refresh: '刷新',
      repairPending: '报修待办',
      complaintPending: '投诉待办',
      purchasePending: '采购待办',
      collectionPending: '物品领用待办',
      contractApplyPending: '合同起草待办',
      contractChangePending: '合同变更待办',
      allocationPending: '调拨待办',
      itemReleasePending: '物品放行待办',
      visitPending: '访客待办',
      repairCompleted: '报修已办',
      complaintCompleted: '投诉已办',
      purchaseCompleted: '采购已办',
      collectionCompleted: '物品领用已办',
      contractApplyCompleted: '合同起草已办',
      contractChangeCompleted: '合同变更已办',
      allocationCompleted: '调拨已办',
      itemReleaseCompleted: '物品放行已办',
      visitCompleted: '访客已办',
      pending: '待办',
completed: '已办'
    }
  },
  'zh-TW': {
    newOaWorkflowDoing: {
      myPending: '我的待辦',
      myCompleted: '我的已辦',
      refresh: '刷新',
      repairPending: '報修待辦',
      complaintPending: '投訴待辦',
      purchasePending: '採購待辦',
      collectionPending: '物品領用待辦',
      contractApplyPending: '合同起草待辦',
      contractChangePending: '合同變更待辦',
      allocationPending: '調撥待辦',
      itemReleasePending: '物品放行待辦',
      visitPending: '訪客待辦',
      repairCompleted: '報修已辦',
      complaintCompleted: '投訴已辦',
      purchaseCompleted: '採購已辦',
      collectionCompleted: '物品領用已辦',
      contractApplyCompleted: '合同起草已辦',
      contractChangeCompleted: '合同變更已辦',
      allocationCompleted: '調撥已辦',
      itemReleaseCompleted: '物品放行已辦',
      visitCompleted: '訪客已辦',
      pending: '待辦',
      completed: '已辦'
    }
  }
}